import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107113Status: 'idle',
    startProcess107113Error: undefined as any,
    loadUserParamsProcess107113Status: 'idle',
    loadUserParamsProcess107113Error: undefined as any,

    process107113List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107113 = createAsyncThunk('process107113Slice/startProcess107113', async ({ process107113 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107113/`,
        prepareData(process107113),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107113Status } = getState().process107113Slice
        return startProcess107113Status !== 'pending'
    }
})

export const loadUserParamsProcess107113 = createAsyncThunk('process107113Slice/loadUserParamsProcess107113', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107113/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107113Status } = getState().process107113Slice
        return loadUserParamsProcess107113Status !== 'pending'
    }
})

const Process107113Slice = createSlice({
    name: 'process107113Slice',
    initialState,
    reducers: {
        resetstartProcess107113: (state) => {
            state.job = undefined
            state.startProcess107113Error = undefined
        },
        resetstartProcess107113Error: (state) => {
            state.startProcess107113Error = undefined
        },
        resetloadUserParamsProcess107113: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107113Error = undefined
        },
        resetloadUserParamsProcess107113Error: (state) => {
            state.loadUserParamsProcess107113Error = undefined
        },
        removeFromProcess107113ListById: (state, action) => {
            state.process107113List = state.process107113List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107113ListByIds: (state, action) => {
            state.process107113List = state.process107113List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107113List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107113Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107113List = []
            state.startProcess107113Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107113.pending, (state) => {
            state.startProcess107113Status = 'pending'
            state.startProcess107113Error = undefined
        })
        builder.addCase(startProcess107113.fulfilled, (state, action) => {
            state.startProcess107113Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107113.rejected, (state, action) => {
            state.startProcess107113Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107113Error = action.error.message
            } else {
                state.startProcess107113Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107113.pending, (state) => {
            state.loadUserParamsProcess107113Status = 'pending'
            state.loadUserParamsProcess107113Error = undefined
        })
        builder.addCase(loadUserParamsProcess107113.fulfilled, (state, action) => {
            state.loadUserParamsProcess107113Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107113.rejected, (state, action) => {
            state.loadUserParamsProcess107113Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107113Error = action.error.message
            } else {
                state.loadUserParamsProcess107113Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107113,
    resetstartProcess107113Error,
    resetloadUserParamsProcess107113,
    resetloadUserParamsProcess107113Error,
    removeFromProcess107113ListById,
    removeFromProcess107113ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107113Slice.actions
export default Process107113Slice.reducer
